export const PORTFOLIO_CATEGORIES = [
  { id: 'all', name: 'All' },
  { id: 'vision', name: 'Computer Vision' },
  { id: 'systems', name: 'Systems' },
  { id: 'llm', name: 'LLM' },
  { id: 'vlm', name: 'Multimodal' },
  { id: 'avatar', name: 'Avatars' },
];

export const PORTFOLIO_CHALLENGES = [
  {
    id: 'face-security',
    label: 'Find face / anti-spoof',
    hint: 'Biometrics that reject spoofs',
    matchIds: [12, 13, 14],
  },
  {
    id: 'traffic',
    label: 'Find traffic / ANPR',
    hint: 'Roads, plates, violations',
    matchIds: [4, 5],
  },
  {
    id: 'crowd',
    label: 'Find crowd ops',
    hint: 'Counting and density',
    matchIds: [6],
  },
  {
    id: 'language',
    label: 'Find language product',
    hint: 'Chat, content, matching',
    matchIds: [10, 11, 15, 16],
  },
  {
    id: 'avatar',
    label: 'Find an avatar demo',
    hint: 'Acting, emoji, or singing',
    matchIds: [7, 8, 9],
  },
];

export const PORTFOLIO_PROJECTS = [
  {
    id: 1,
    title: 'Advanced Detection & Tracking',
    category: 'systems',
    description: 'Multi-object detection and tracking for surveillance and security feeds.',
    video: '/assets/videos/AdvancedDetectiionAndTracking.mp4',
    thumbnail: '/assets/images/thumbs/advanced-detection.jpg',
    technologies: ['OpenCV', 'YOLO', 'Python'],
    features: ['Real-time tracking', 'Multi-object', 'High accuracy'],
  },
  {
    id: 2,
    title: 'Distress Detection',
    category: 'vision',
    description: 'Flags emergency postures and distress cues for faster response.',
    video: '/assets/videos/DistressDetection.mp4',
    thumbnail: '/assets/images/thumbs/distress.jpg',
    technologies: ['Computer Vision', 'Deep Learning', 'TensorFlow'],
    features: ['Emergency cues', 'Real-time alerts', 'High sensitivity'],
  },
  {
    id: 3,
    title: 'Custom Detection & Tracking',
    category: 'vision',
    description: 'Configurable detectors tuned to your objects and environments.',
    video: '/assets/videos/CustomDetection-Tracking.mp4',
    thumbnail: '/assets/images/thumbs/custom-detection.jpg',
    technologies: ['OpenCV', 'Custom Models', 'Python'],
    features: ['Configurable', 'Domain-tuned', 'Adaptive'],
  },
  {
    id: 4,
    title: 'Automatic Number Plate Recognition',
    category: 'vision',
    description: 'ANPR for vehicle ID and traffic management with high OCR accuracy.',
    video: '/assets/videos/AutomaticNumberPlateDetection-ANPR.mp4',
    thumbnail: '/assets/images/thumbs/anpr.jpg',
    technologies: ['OpenCV', 'OCR', 'Computer Vision'],
    features: ['High accuracy', 'Real-time', 'Multi-format'],
  },
  {
    id: 5,
    title: 'Traffic Violation Detection',
    category: 'systems',
    description: 'Detects and records violations for enforcement workflows.',
    video: '/assets/videos/Traffic_Violation.mp4',
    thumbnail: '/assets/images/thumbs/traffic.jpg',
    technologies: ['Computer Vision', 'AI Models', 'Real-time'],
    features: ['Violation detection', 'Evidence capture', 'Live monitoring'],
  },
  {
    id: 6,
    title: 'Crowd Detection & Counting',
    category: 'systems',
    description: 'Density estimation and counting for public spaces and venues.',
    video: '/assets/videos/CrowdDetectionTracking-Counting.mp4',
    thumbnail: '/assets/images/thumbs/crowd.jpg',
    technologies: ['Deep Learning', 'Computer Vision', 'Analytics'],
    features: ['Counting', 'Density', 'Behavior signals'],
  },
  {
    id: 7,
    title: 'AI Avatars — Acting',
    category: 'avatar',
    description: 'Expressive avatars for performance and virtual presence.',
    video: '/assets/videos/AI_Avatar-Acting.mp4',
    thumbnail: '/assets/images/thumbs/avatar-acting.jpg',
    technologies: ['Deep Learning', '3D Animation', 'Neural Nets'],
    features: ['Natural acting', 'Expressions', 'Real-time'],
  },
  {
    id: 8,
    title: 'AI Avatars — Emoji',
    category: 'avatar',
    description: 'Emotion-driven avatar reactions for interactive products.',
    video: '/assets/videos/AI_Avatar-Emoji.mp4',
    thumbnail: '/assets/images/thumbs/avatar-emoji.jpg',
    technologies: ['Emotion AI', 'Animation', 'Real-time'],
    features: ['Emotion display', 'Emoji motion', 'Interactive'],
  },
  {
    id: 9,
    title: 'AI Avatars — Singing',
    category: 'avatar',
    description: 'Lip-synced musical avatars with expressive delivery.',
    video: '/assets/videos/AI_Avatar-Sing.mp4',
    thumbnail: '/assets/images/thumbs/avatar-sing.jpg',
    technologies: ['Voice Synthesis', 'Lip Sync', 'Music AI'],
    features: ['Voice', 'Lip sync', 'Musical expression'],
  },
  {
    id: 10,
    title: 'WebChat — Site Chatbot',
    category: 'llm',
    description: 'Conversational agents grounded in your website content.',
    video: '/assets/videos/WebChat-Chat-with-Websites.mp4',
    thumbnail: '/assets/images/thumbs/webchat.jpg',
    technologies: ['NLP', 'Web Integration', 'Real-time Chat'],
    features: ['Fast setup', 'Site grounding', 'Natural chat'],
  },
  {
    id: 11,
    title: 'ContentVerse',
    category: 'llm',
    description: 'Content generation for marketing and ops workflows.',
    video: '/assets/videos/Content_Verse.mp4',
    thumbnail: '/assets/images/thumbs/content-verse.jpg',
    technologies: ['GPT Models', 'Content AI', 'Automation'],
    features: ['Fast drafts', 'Multiple formats', 'Editable'],
  },
  {
    id: 12,
    title: 'Face Detection & Recognition',
    category: 'vision',
    description: 'Real-time face detect and match for security use cases.',
    video: '/assets/videos/Face-Detection-Recognition.mp4',
    thumbnail: '/assets/images/thumbs/face.jpg',
    technologies: ['OpenCV', 'TensorFlow', 'Python'],
    features: ['Real-time', 'High accuracy', 'Multi-platform'],
  },
  {
    id: 13,
    title: 'Anti-Spoof Detection',
    category: 'vision',
    description: 'Rejects print and replay attacks in biometric flows.',
    video: '/assets/videos/AntispoofDetection.mp4',
    thumbnail: '/assets/images/thumbs/antispoof.jpg',
    technologies: ['Deep Learning', 'Anti-spoofing', 'Security'],
    features: ['Spoof reject', 'Liveness', 'Real-time'],
  },
  {
    id: 14,
    title: 'Facial Landmarks',
    category: 'vision',
    description: 'Dense landmark mapping for analysis and biometrics.',
    video: '/assets/videos/Facial_Landmark.mp4',
    thumbnail: '/assets/images/thumbs/facial-landmark.jpg',
    technologies: ['Computer Vision', 'Facial Analysis', 'ML'],
    features: ['68-point map', 'Precise', 'Real-time'],
  },
  {
    id: 15,
    title: 'LLM & Decision Integration',
    category: 'llm',
    description: 'LLMs embedded into decision and automation pipelines.',
    video: '/assets/videos/LLM_Integration.mp4',
    thumbnail: '/assets/images/thumbs/llm-integration.jpg',
    technologies: ['LLMs', 'Decision AI', 'Integration'],
    features: ['Decisions', 'Automation', 'Business hooks'],
  },
  {
    id: 16,
    title: 'Candidate & Job Matching',
    category: 'llm',
    description: 'Semantic matching between resumes and open roles.',
    video: '/assets/videos/CaniddateJobMaching.mp4',
    thumbnail: '/assets/images/thumbs/candidate-job.jpg',
    technologies: ['NLP', 'Matching', 'Recruitment AI'],
    features: ['Smart match', 'Resume parse', 'Recommendations'],
  },
  {
    id: 17,
    title: 'Visual Question Answering',
    category: 'vlm',
    description: 'Ask questions about images with multimodal understanding.',
    image: '/assets/images/samples/visual-qa-dataset.jpg',
    thumbnail: '/assets/images/samples/visual-qa-dataset.jpg',
    video: null,
    isImage: true,
    technologies: ['CLIP', 'BERT', 'PyTorch'],
    features: ['Image understanding', 'Q&A', 'Multimodal'],
  },
];
